<div class="transcript" (scroll)="onUserScroll()">
  @if (cues().length === 0) {
    <p class="transcript__empty">{{ "Episodes details.No transcript" | translate }}</p>
  }
  @for (cue of cues(); track $index; let i = $index) {
    @if (showSpeaker(i)) {
      <div class="transcript__speaker">{{ cue.speaker }}</div>
    }
    <p #cueEl
       class="transcript__line"
       [class.transcript__line--active]="i === activeIndex"
       (click)="onCueClick(cue)">
      {{ cue.text }}
    </p>
  }
</div>
